
import './Files.scss'
import ConfirmationDialog from '../../../../CommonComponents/confirmation_dialog/ConfirmationDialog'
import useUrlParams from '../../../hooks/useUrlParams'
import GroundFiles from './ground_files/GroundFiles'
import OnboardFiles from './onboard_files/OnboardFiles'
import { useState } from 'react'
import useFiles from '../../../hooks/useFiles'
import useScenario from '../../../hooks/useScenario'
import { SCENARIO_DEPLOYMENT_TYPES } from '../../../../simulate/constants'

type actionFile = {
    status: string | null;
    fileId: string | null;
}

const Files = () => {
    const { tab_name, dashboard } = useUrlParams()
    const { scenario } = useScenario()
    const isValidateSummary =
        (scenario?.scenarioDeploymentType ?? '').toUpperCase() === SCENARIO_DEPLOYMENT_TYPES.VALIDATE &&
        dashboard === 'summary'

    const [actionFileId, setActionFileId] = useState<actionFile>({ status: null, fileId: null })
    const [typeOfAction, setTypeOfAction] = useState<'delete' | 'cancel' | 'pause' | 'resume' | 'discard'>('delete')
    const { deleteFileFromMinio, cancelUploadToSatellite, ResumeThePausedFile, pauseTheUplinkingFile, onBoardChangePriority, deleteDownloadFile, refreshQueue } = useFiles();

    const descriptionText =
        typeOfAction === 'delete' ?
            (actionFileId?.status === 'Uplinking' || actionFileId?.status === 'Planned') ?
                'On confirmation, file uplink operation will be terminated and the file would be deleted from the system.Once deleted, the file cannot be retrieved.' :
                (actionFileId?.status === 'download_pending' || actionFileId?.status === 'download_inprogress' || actionFileId?.status === 'download_success' || actionFileId?.status === 'download_cancel') ?
                    'On confirmation, selected file will be deleted from onboard storage. Once confirmed, the file will no longer be visible in the list of onboard files.' :
                    "On confirmation, the file would be deleted from the system. Once deleted, the file cannot be retrieved." :
            typeOfAction === 'cancel' ?
                (actionFileId?.status === "FILE_DL_PRIORITY_LOW" || actionFileId?.status === "FILE_DL_PRIORITY_DEFAULT" || actionFileId?.status === "FILE_DL_PRIORITY_IMMEDIATE" || actionFileId?.status === "FILE_DL_PRIORITY_HIGH") ?
                    'On confirmation, downlink priority for the selected file will be changed. Once confirmed, a TC will be scheduled to update the downlink queue on the basis of priority changes done.' :
                    'On confirmation, file uplink operation will be cancelled. Once cancelled, the file can be uplinked again through console.' :
                typeOfAction === 'pause' ?
                    'On confirmation, file uplink operation will be paused. Paused file can be uplinked again by restarting the uplink.' :
                    typeOfAction === 'resume' ?
                        'On confirmation, file uplink operation will resume. After resuming, the file will be uplinked when in contact.' :
                        typeOfAction === 'discard' ?
                            'Please confirm if the onboard Payload Server is ON. Once confirmed, the current status of all the downlink files will be fetched.' :
                            ''

    const titleText =
        typeOfAction === 'delete' ?
            `Delete File?` :
            (actionFileId?.status === 'download_pending' || actionFileId?.status === 'download_inprogress' || actionFileId?.status === 'download_success' || actionFileId?.status === 'download_cancel') ?
                'Delete File Onboard?' :
                typeOfAction === 'cancel' ?
                    (actionFileId?.status === "FILE_DL_PRIORITY_LOW" || actionFileId?.status === "FILE_DL_PRIORITY_DEFAULT" || actionFileId?.status === "FILE_DL_PRIORITY_IMMEDIATE" || actionFileId?.status === "FILE_DL_PRIORITY_HIGH") ?
                        'Change File Downlink Priority?' :
                        'Cancel File Uplink To Satellite' :
                    typeOfAction === 'pause' ?
                        'Pause File Uplink To Satellite' :
                        typeOfAction === 'resume' ?
                            'Resume File Uplink To Satellite' : typeOfAction === 'discard' ? 'Payload Server State' : ''

    const handleConfirm = () => {
        if (typeOfAction === 'delete') {
            if (actionFileId?.status === 'download_pending' || actionFileId?.status === 'download_inprogress' || actionFileId?.status === 'download_success' || actionFileId?.status === 'download_cancel') {
                deleteDownloadFile(actionFileId?.fileId ?? '');
            } else {
                deleteFileFromMinio(actionFileId?.fileId)
            }
        } else if (typeOfAction === 'cancel') {
            if (actionFileId?.status === "FILE_DL_PRIORITY_LOW" || actionFileId?.status === "FILE_DL_PRIORITY_DEFAULT" || actionFileId?.status === "FILE_DL_PRIORITY_IMMEDIATE" || actionFileId?.status === "FILE_DL_PRIORITY_HIGH") {
                onBoardChangePriority(actionFileId?.fileId ?? '', actionFileId?.status ?? '');
            } else {
                cancelUploadToSatellite(actionFileId?.fileId)
            }
        } else if (typeOfAction === 'pause') {
            pauseTheUplinkingFile(actionFileId?.fileId)
        } else if (typeOfAction === 'resume') {
            ResumeThePausedFile(actionFileId?.fileId)
        } else if (typeOfAction === 'discard') {
            refreshQueue(actionFileId?.fileId ?? '');
        }
        setActionFileId({ status: null, fileId: null })
    }
    return (
        <div className='files__container__wrapper'>
            <div className='file-tab-container'>
                {tab_name === 'files-ground-files' && <GroundFiles isReadOnlyActions={isValidateSummary} setTypeOfAction={setTypeOfAction} setActionFileId={setActionFileId} />}
                {tab_name === 'files-onboard-files' && <OnboardFiles isReadOnlyActions={isValidateSummary} typeOfAction={typeOfAction} actionFileId={actionFileId} setTypeOfAction={setTypeOfAction} setActionFileId={setActionFileId} />}
            </div>
            {/* CONFIRMATION DIALOUGE */}
            <ConfirmationDialog
                type={typeOfAction === 'delete' ? typeOfAction : typeOfAction === 'discard' ? typeOfAction : 'cancel'}
                open={Boolean(actionFileId?.fileId)}
                title={titleText}
                description={descriptionText}
                onCancel={() => setActionFileId({ status: null, fileId: null })}
                onConfirm={() => handleConfirm()}
                confirm_button_text={'Confirm'}
                onDiscard={() => setActionFileId({ status: null, fileId: null })}
            />
        </div>
    )
}

export default Files;